import { createStore, applyMiddleware } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import { createBrowserHistory as createHistory } from "history";
import rootReducer from "./modules/reducers";
import {
  entityMiddleware,
  EntityFrameworkConfig
} from "clavis-nxt-components-custdevtm";
import { composeWithDevTools } from "redux-devtools-extension";

EntityFrameworkConfig.serverName = "";
EntityFrameworkConfig.contextPath = "clavis-swift";

export const history = createHistory({
  basename: process.env.REACT_APP_ROUTER_BASE || ""
});

//EXPORT HISTORY OBJECT TO GLOBAL FOR MODULES
window.clavisNxtHistory = history;

const initialState = {};
const middleware = [thunk, routerMiddleware(history), entityMiddleware];

const composeEnhancers = composeWithDevTools({
  name: "Clavis NXT - Web Platform",
  trace: true,
  traceLimit: 25
});

const composedEnhancers = composeEnhancers(applyMiddleware(...middleware));

const store = createStore(
  connectRouter(history)(rootReducer),
  initialState,
  composedEnhancers
);

export default store;
